// src/services/historicoService.js (exemplo de nome)
import { getAuth } from 'firebase/auth';

const API_BASE_URL = process.env.REACT_APP_API_SUPORTE_URL;
const API_HISTORICO_URL = `${API_BASE_URL}/historico/acessos`;

// Helper: faz fetch com Authorization: Bearer <ID token>
async function authFetch(input, init = {}, { forceRefresh = false } = {}) {
  const auth = getAuth();
  const user = auth.currentUser;
  const idToken = user ? await user.getIdToken(forceRefresh) : null;
  if (!idToken) throw new Error('Missing token');

  const headers = new Headers(init.headers || {});
  if (!headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  headers.set('Authorization', `Bearer ${idToken}`);

  return fetch(input, { ...init, headers });
}

/**
 * Busca apenas a duração da sessão de um usuário pelo UID.
 */
export const getDuracaoSessao = async (uid) => {
  const url = `${API_HISTORICO_URL}/${encodeURIComponent(uid)}`;

  // 1ª tentativa com token atual
  let res = await authFetch(url, { method: 'GET' });

  // Se 401, força refresh e tenta 1 vez
  if (res.status === 401) {
    res = await authFetch(url, { method: 'GET' }, { forceRefresh: true });
  }

  if (!res.ok) {
    throw new Error(`Falha ao buscar duração da sessão (HTTP ${res.status})`);
  }

  const data = await res.json();

  if (!data?.duracao) {
    throw new Error('Duração da sessão não encontrada na resposta da API.');
  }

  return data.duracao;
};

/**
 * Busca o histórico de sessões do usuário filtrado por período.
 */
export const fetchHistoricoAcessosPorPeriodo = async (uid, periodo) => {
  const qs = new URLSearchParams({ periodo: String(periodo) });
  const url = `${API_HISTORICO_URL}/${encodeURIComponent(uid)}?${qs}`;

  // 1ª tentativa com token atual
  let res = await authFetch(url, { method: 'GET' });

  // Se 401, força refresh e tenta 1 vez
  if (res.status === 401) {
    res = await authFetch(url, { method: 'GET' }, { forceRefresh: true });
  }

  if (!res.ok) {
    throw new Error(`Falha ao buscar histórico (HTTP ${res.status})`);
  }

  const data = await res.json();

  if (!Array.isArray(data.sessoes)) {
    throw new Error('Histórico de acessos não retornado em formato de array.');
  }

  return data.sessoes;
};
